export const server = process.env.REACT_APP_server;
export const FacebookAppID = process.env.REACT_APP_FacebookAppID;
export const GoogleclientId = process.env.REACT_APP_GoogleclientId;
